import PropTypes from 'prop-types';
import React, {memo} from 'react';

// Bypassing VelocityComponent as it crashes with React 17+ on some node versions.
const AppAnimate = (props) => {
  return <>{props.children}</>;
};

AppAnimate.propTypes = {
  // Renders `<>{children}</>`, so any renderable node (incl. multiple children /
  // an array) is valid. Declaring `element` (a single element) wrongly warned
  // "Invalid prop children of type array" on every page that passes >1 child.
  children: PropTypes.node.isRequired,
};

AppAnimate.defaultProps = {
  animation: 'transition.fadeIn',
  runOnMount: true,
  targetQuerySelector: null,
  interruptBehavior: 'stop',
  visibility: 'visible',
  duration: 400,
  delay: 100,
  easing: [0.4, 0.0, 0.2, 1],
  display: null,
  setRef: undefined,
};

export default memo(AppAnimate);
